export const QueryFilterType = {
	String: 'string',
	Number: 'number',
	Date: 'date',
	DateTime: 'datetime',
	Select: 'select',
	DynamicTags: 'dynamic-tags',
	Link: 'link',
	TreeSelect: 'treeselect',
	Target: 'target',
	OwnerModel: 'ownermodel',
	Boolean: 'boolean'
} as const;

export type QueryFilterType = (typeof QueryFilterType)[keyof typeof QueryFilterType];

export const QueryFilterConstraint = {
	Is: 'is',
	Contains: 'contains',
	NotContains: 'not contains',
	ContainsPhrase: 'contains phrase',
	NotContainsPhrase: 'not contains phrase',
	ArrayContains: 'ARRAY_CONTAINS',
	NotArrayContains: 'NOT ARRAY_CONTAINS',
	Exact: 'exact',
	Gte: 'gte',
	Lte: 'lte',
	Gt: 'gt',
	Lt: 'lt',
	IsEmpty: 'is empty',
	IsNotEmpty: 'is not empty'
} as const;

export const QueryFilterValueFlag = {
	IsNull: 'isNull',
	IsEmpty: 'isEmpty'
} as const;

export const QueryFilterLogic = {
	And: 'AND',
	Or: 'OR'
} as const;
